import logoBzc from 'Assets/images/BzcLogo1.svg';
import React, { useEffect } from 'react';
import styled from 'styled-components/macro';
import { PageContainer } from 'Ui';
import { theme } from 'Ui/theme';
import AccountMenu from './AccountMenu';
import AnonymousHeader from './AnonymousHeader';
import HeaderBasket from '../HeaderBasket';
import AuthStore from 'Store/AuthStore';
import BannerApp from 'Components/BannerApp';
import { isAndroid, isIOS } from 'react-device-detect';
import UiStore from 'Store/UiStore';
import { storageFactory } from 'Libs/storageFactory';
import BirthdayReminderModal from 'Components/modals/BirthReminderModal';
import {
  dateDiff,
  timestampAndCount,
  createCookieBirtdayReminder,
} from 'Utils/date';
import Cookie from 'js-cookie';
import WishListMenu from './WishListMenu';
import SearchInput from '../MobileHeader/SearchInput';
import { getCookie } from 'Utils/cookie';
import { getUserType } from 'Utils/memberType';
import { createAnonymousSession } from 'Utils/login';
import { useApolloClient } from '@apollo/client';
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';
import {
  CenteredNav,
  HeaderBar,
  HeaderIcons,
  HeaderOuter,
  LogoTitle,
  PageHeaderContainer,
} from '.';
import { HeaderNavigation } from './HeaderNavigation';
import { Link } from 'react-router-dom';

const LogoStyled = styled.img`
  width: 29rem;
  height: 100%;
`;

const TopBar = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  height: 7.5rem;
  align-items: center !important;
  /* padding-bottom: 12px; */
`;

const FixBar = styled.div`
  position: sticky;
  top: 0;
  left: 0;
  width: 100vw;
  background-color: #fff;
  z-index: 10001;
  box-shadow: 0px 1px 9px 0px rgba(0, 0, 0, 0.1);
  .addShadow {
    box-shadow: 0px 1px 9px 0px rgba(0, 0, 0, 0.1);
  }
`;

const SearchInputDiv = styled.div`
  display: flex;
  border-bottom: 1px solid #888;
  box-sizing: border-box;
  align-self: end;
  margin-right: 1.5rem;
  width: 16.8rem;
  &:hover {
    cursor: text;
  }
`;

export default () => {
  const apolloClient = useApolloClient();
  const setAuth = AuthStore.useStoreActions((actions) => actions.setAuth);
  const initAuth = AuthStore.useStoreActions((actions) => actions.initAuth);
  const member = AuthStore.useStoreState((state) => state.member);
  const sessionMemberType = AuthStore.useStoreState(
    (state) => state.sessionMemberType
  );
  const birthdayReminder = Cookie.get('birthdayReminder');
  const marketingStore = UiStore.useStoreState(
    (state) => state.cookieMarketing
  );

  const getBirthdayReminder = () => {
    if (member) {
      if (!member.birthDate) {
        if (!!birthdayReminder) {
          const [timestamp] = timestampAndCount(birthdayReminder);
          if (dateDiff(timestamp) >= 10) {
            BirthdayReminderModal({});
          }
        } else {
          createCookieBirtdayReminder();
        }
      }
    }
  };

  const loggedIn = AuthStore.useStoreState((state) => state.isLoggedIn);

  const cookieMobileAppPopup = UiStore.useStoreState(
    (state) => state.cookieMobileApp
  );
  const localStore = storageFactory(() => localStorage);

  const isLoggedIn =
    loggedIn || !!localStore.getItem('isLoggedIn') ? true : false;

  // if (!!localStore.getItem('isLoggedIn') === false) {
  //   return <AnonymousHeader />;
  // } else if (!!localStore.getItem('isLoggedIn') === false && !loggedIn) {
  //   return <AnonymousHeader />;
  // }

  if (!Cookie.get('ssession')) {
    createAnonymousSession(apolloClient)
      .then((data) => {
        if (data) {
          const payload = {
            jwt: data.createAnonymousSession.jwt,
            sessionId: data.createAnonymousSession.sessionId,
            member: data.createAnonymousSession.member,
          };
          setAuth(payload);
          initAuth();
        }
      })
      .catch((e) => console.log(e));
  }

  if (loggedIn) {
    if (Cookie.get('RgpdBanner') && marketingStore) {
      getBirthdayReminder();
    }
  }

  useEffect(() => {
    const scrollShadow: any = document.getElementById('addShadowJs');
    const detectScroll = (event: any) => {
      const getScroll = event.currentTarget.scrollY;
      if (getScroll > 40) {
        scrollShadow.style.boxShadow = '0px 1px 9px 0px rgba(0, 0, 0, 0.1)';
      } else {
        scrollShadow.style.boxShadow = '0px 1px 9px 0px rgba(0, 0, 0, 0.1)';
      }
    };

    window.addEventListener('scroll', detectScroll);
    return () => {
      window.removeEventListener('scroll', detectScroll);
    };
  }, []);

  const searchString = UiStore.useStoreState(
    (state) => state.searchStringHeader
  );
  // @ts-ignore
  const { t } = useTranslation('header', { useSuspense: false });
  const InterogationPoint = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 48 48"
      fill="none"
    >
      <circle cx="24" cy="24" r="22" stroke="black" stroke-width="2.5" />
      <path
        d="M20 18.5C20 16.015 21.79 14 24 14C26.21 14 28 16.015 28 18.5C28 20.5 26.8 22.2 25 23L24 23.5V27"
        stroke="black"
        stroke-width="2.5"
        stroke-linecap="round"
      />
      <circle cx="24" cy="31" r="1.5" fill="black" />
    </svg>
  );
  return (
    <>
      {/* {!loggedIn && <AnonymousHeader />} */}

      {/* {isLoggedIn && ( */}
      <>
        {cookieMobileAppPopup && (isAndroid || isIOS) && (
          <BannerApp android={isAndroid} />
        )}

        <HeaderOuter id="addShadowJs">
          {cookieMobileAppPopup && (isAndroid || isIOS) && (
            <BannerApp android={isAndroid} />
          )}

          <HeaderBar>
            <a href="/">
              <LogoTitle>Bazarchic</LogoTitle>
            </a>

            <CenteredNav>
              <HeaderNavigation />
            </CenteredNav>

            <HeaderIcons>
              {/* Lien contact retiré du header par la maquette BZCFRONT-2255,
                  code conservé le temps de la validation :
              <div>
                <a href={'/contact/'}>
                  <InterogationPoint />
                </a>
              </div>
              */}
              <div>
                <AccountMenu />
              </div>
              <div>
                <WishListMenu />
              </div>
              <div className="iconTextColor">
                <HeaderBasket />
              </div>
            </HeaderIcons>
          </HeaderBar>
        </HeaderOuter>
      </>
      {/* )} */}
    </>
  );
};
